/**
 * Backend stores category/overall scores as 0-5 float (raw 1-5 rating average).
 * UI renders them as percentages. Single source of truth for the conversion.
 */
export function scoreToPercent(score0to5: number): number {
  if (!Number.isFinite(score0to5) || score0to5 <= 0) return 0
  return Math.round((score0to5 / 5) * 100)
}

/** Validation score display: green ≥80, gold gradient ≥50 & <80, darker gold <50 */
export function scoreDisplayClasses(score: number): {
  text: string
  pill: string
} {
  if (score >= 80) {
    return {
      text: 'text-[#057a36] dark:text-[#00A63E]',
      pill: 'bg-[#00A63E]/15 ring-1 ring-[#00A63E]/45 dark:ring-[#00A63E]/25',
    }
  }
  if (score >= 50) {
    return {
      text: 'text-[#8a5e1a] dark:text-[#F6CB86]',
      pill: 'bg-[#E0A263]/15 ring-1 ring-[#E0A263]/55 dark:ring-[#F6CB86]/40',
    }
  }
  return {
    text: 'text-[#8a5e1a] dark:text-[#F6CB86]',
    pill: 'bg-[#E0A263]/18 ring-1 ring-[#E0A263]/55 dark:ring-[#F6CB86]/35',
  }
}
